import { Link } from 'react-router-dom';
import { mangaList, latestMangaIds } from '@/mocks/manga';

export default function LatestUpdates() {
  const latest = latestMangaIds.map((id) => mangaList.find((m) => m.id === id)!);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6" data-product-shop="">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">刚刚更新的漫画章节，追更不容错过</p>
          </div>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
          {latest.map((manga, index) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}/1`}
              className={`flex items-center gap-4 p-4 transition-colors hover:bg-primary-50/50 cursor-pointer ${
                index > 0 ? 'border-t border-background-100' : ''
              }`}
            >
              {/* Rank */}
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold shrink-0 ${
                index < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {index + 1}
              </div>

              {/* Cover */}
              <div className="w-12 h-16 rounded overflow-hidden shrink-0">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top"
                  width="48"
                  height="64"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 truncate">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">
                  {manga.latestChapter}
                </p>
              </div>

              {/* Meta */}
              <div className="hidden sm:flex items-center gap-4 text-xs text-foreground-400 shrink-0">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {(manga.views / 10000).toFixed(0)}万
                </span>
                <span>{manga.status}</span>
              </div>

              <div className="text-xs text-foreground-400 shrink-0 hidden md:block">
                {manga.updatedAt}
              </div>

              <i className="ri-arrow-right-s-line text-foreground-300 shrink-0"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}